import * as Yup from 'yup';

export const detailsCompanyValidationSchema = Yup.object({
  name: Yup.string()
    .required('Required field')
    .min(1, 'Must be at least 1 character')
    .max(50, 'Must be at most 50 characters'),
  email: Yup.string()
    .email('Invalid E-mail')
    .required('Required field')
    .min(1, 'Must be at least 1 character')
    .max(250, 'Must be at most 250 characters'),
  street: Yup.string().required('Street is required'),
  house_number: Yup.string()
    .transform((value) => (value === '' ? null : value))
    .nullable(),
  zip_code: Yup.string().required('Zip code is required'),
  city: Yup.string().required('City is required'),
  state: Yup.string()
    .transform((value) => (value === '' ? null : value))
    .nullable(),
  country: Yup.string()
    .required('Country is required')
    .length(2, 'Country code must be exactly 2 characters'),
});
